import React, { createContext, useState, useContext, useEffect } from 'react';
import { onAuthEvent, AUTH_EVENTS } from '../utils/userPreferencesCookie';

const LiquidGlassContext = createContext();

export const LiquidGlassProvider = ({ children }) => {
  const [liquidGlassEnabled, setLiquidGlassEnabled] = useState(() => {
    // Par défaut désactivé, mais peut être activé par l'utilisateur
    const saved = localStorage.getItem('liquidGlassEnabled');
    return saved !== null ? JSON.parse(saved) : false;
  });

  const toggleLiquidGlass = () => {
    setLiquidGlassEnabled((prev) => {
      const newValue = !prev;
      localStorage.setItem('liquidGlassEnabled', JSON.stringify(newValue));
      return newValue;
    });
  };

  useEffect(() => {
    localStorage.setItem('liquidGlassEnabled', JSON.stringify(liquidGlassEnabled));
  }, [liquidGlassEnabled]);

  // Écouter les événements d'authentification pour réinitialiser/restaurer l'état
  useEffect(() => {
    const handleSignedOut = () => {
      setLiquidGlassEnabled(false);
    };
    const handleSignedIn = () => {
      const saved = localStorage.getItem('liquidGlassEnabled');
      if (saved !== null) {
        setLiquidGlassEnabled(JSON.parse(saved));
      }
    };
    const cleanupOut = onAuthEvent(AUTH_EVENTS.SIGNED_OUT, handleSignedOut);
    const cleanupIn = onAuthEvent(AUTH_EVENTS.SIGNED_IN, handleSignedIn);
    return () => { cleanupOut(); cleanupIn(); };
  }, []);

  return (
    <LiquidGlassContext.Provider value={{ liquidGlassEnabled, toggleLiquidGlass }}>
      {children}
    </LiquidGlassContext.Provider>
  );
};

export const useLiquidGlass = () => {
  const context = useContext(LiquidGlassContext);
  if (context === undefined) {
    throw new Error('useLiquidGlass must be used within a LiquidGlassProvider');
  }
  return context;
};
